/**
 * Point a Vidstack provider at the app's bundled hls.js with the given config. Shared by
 * `VideoPlayer` and the Speedy player (F-129), so both wire hls.js the same way.
 *
 * Only an hls.js provider is touched. Vidstack prefers hls.js wherever MediaSource or Apple's
 * ManagedMediaSource exists, which includes iPhones on iOS 17.1+; only older iPhones play HLS
 * natively, and this is a no-op there.
 */
import { isHLSProvider, type MediaProviderAdapter } from '@vidstack/react';
import Hls, { type HlsConfig } from 'hls.js';

export function configureHlsProvider(
  provider: MediaProviderAdapter | null,
  config: Partial<HlsConfig>,
): void {
  if (!provider || !isHLSProvider(provider)) return;
  // Our bundled, version-matched hls.js, so a custom loader's base class matches the runtime.
  provider.library = Hls;
  provider.config = config;
}
